import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import T from '../../Utils/Locale';
import PurchaseType from '../Purchase/PurchaseType';
const NextAction = ({ items, hasSelectedBookingTime = false }) => {
    const onlyRegistration = () => {
        for (let i = 0; i < items.length; i++) {
            if (items[i].purchase_type !== 'registration')
                return false;
        }
        return true;
    };
    const nextDescriptionKey = onlyRegistration() ? 'basket.next.description_registration' : 'basket.next.description';
    /**
     * Get text for a product and purchase type
     *
     * @param item
     *
     * @returns {null|string}
     */
    const getProductText = (item) => {
        const translationParameters = { product: T(`products_specific.${item.product}`) };
        switch (item.purchase_type) {
            case PurchaseType.DIGITAL:
                return item.has_document_waiting_for_payment
                    ? T(`basket.next.${item.purchase_type}.post_created.${item.product}`, translationParameters)
                    : T(`basket.next.${item.purchase_type}.pre_created`, translationParameters);
            case PurchaseType.REVIEW:
            case PurchaseType.ADVICE:
                return T(`basket.next.${item.purchase_type}.${hasSelectedBookingTime ? 'pre_booked' : 'post_booking'}`, translationParameters);
            default:
                return null;
        }
    };
    return (_jsxs("div", Object.assign({ className: 'product-list--card card--item bg-hardly-teal p-6 md:px-8 md:py-4 rounded-xl shadow-hardly-teal mb-4 md:mb-5' }, { children: [_jsx("h2", Object.assign({ className: 'tailwind-reset text-base text-dark-teal-200 mb-2 font-medium' }, { children: T('basket.next.title') })), _jsxs("p", Object.assign({ className: 'tailwind-reset font-normal text-dark-teal-200 leading-relaxed mb-0' }, { children: [items.map((item) => (_jsx("span", Object.assign({ className: 'pr-1' }, { children: getProductText(item) }), item.id))), _jsx("span", Object.assign({ className: 'pr-1' }, { children: T(nextDescriptionKey) }))] }))] })));
};
NextAction.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        product: PropTypes.string.isRequired,
        purchase_type: PropTypes.string.isRequired,
        has_document_waiting_for_payment: PropTypes.bool
    }))
};
export default NextAction;
